/**
 * Small JSON key-value store on localStorage. Every access is guarded: storage can be
 * unavailable (private mode, blocked site data, quota), and the app must still work.
 * Keys match the mobile app's so the formats stay recognizable.
 */
export function readJson<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw == null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

/** Returns false when the value could not be stored. */
export function writeJson(key: string, value: unknown): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function removeKey(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Nothing stored, nothing to remove.
  }
}

export const KEYS = {
  analyticsEnabled: "netkeep.analyticsEnabled",
  scheduleCache: "netkeep.scheduleCache.v1",
  /** No longer used: only read to delete a server address saved by older versions. */
  legacyApiUrl: "netkeep.apiUrl",
  themePreference: "netkeep.themePreference",
  saved: "netkeep.savedCalculations.v1",
} as const;
